import { useRef, useState, useEffect, useMemo, useContext } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import DocumentTitle from "../../components/DocumentTitle/DocumentTitle";
import Erreurs from "../../components/Erreurs/Erreurs";

import InvoiceDetails from "../../components/InvoiceDetails/InvoiceDetails";
import Api from "../../services/Api";
import { ElementContext, UserContext } from "../../services/Context/Context";
import { useRecoilState } from "recoil";
import { loadingState } from "../../recoil/atoms/loadingAtom";
import {commission,expression} from "../../services/Helpers/fonctions";
import RejectionModal from "../../components/RejectionModal/RejectionModal";


const PaymentDetails = () => {
  const componentRef = useRef();
  const navigate = useNavigate();
  const [erreurs, setErreurs] = useState([]);
  const { elementsData } = useContext(ElementContext);
  const {privileges} = useContext(UserContext);
  const [nouveauPrivilege,setNouveauPrivilege] = useState();
  const [annulerPaiement,setAnnulerPaiement] = useState();
  const [nouveauPaiement,setNouveauPaiement ] = useState('');
  const location = useLocation();
  const { id } = useParams();
  const api = new Api();
  const paiement_id = location?.state?.paiementInfo.paiement_id;
  const [isLoading,setIsLoading] = useRecoilState(loadingState);
 
  const [user,setUser] = useState();
  const [validerPaiement,setValiderPaiement] = useState();
  const [isRejectionModalOpen, setIsRejectionModalOpen] = useState(false);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
 
  const [paiementDetail, setPaiementDetail] = useState({
    typeClient: "",
    modeExp: "",
    fullName: "",
    tel: "",
    nif: "",
    chassis: "",
    modeImma: "",
    categorieCg: 0,
    typeCg: 0,
    typeVignette: 0,
    pv: 0,
    cu: 0,
    autorisation_id: 0,
    expressionCg: "",
    isNextStep: 1,
  });
  const [paiementInfo, setPaiementInfo] = useState({
    categorie: "",
    commission: 0,
    vignette: "",
    cartegrise: "",
    categorie_id: 0,
    autorisation: "",
    qrcodepath: "",
    reference: "",
    paiement_id: "",
    document:'',
    created_at: "",
  });
  const [elements, setElements] = useState();
  const back = async () => {
    if(paiementInfo.type_paiement === 'Renouvellement')
      navigate('/payment/other/new')
    else
      navigate('/payment/new');
    //setErreurs([]);
    // var formData = new FormData();
    // formData.append('paiement_id',paiement_id)
    // const {status,messages,} =  await api.apiData('post','/paiement/printed',formData);
    // if(status === 200)
    //   navigate('/payment/new');
    // else
    //   setErreurs(messages)  

  }
  useEffect(() => {
   // console.log(id)
 
    if(id){
      setIsLoading(true);
        api.apiData('get',`/paiement/getpaiementByID/${id}`).then((resp) => {
          if(resp.status === 200 && resp.paiement){
              const paiement = resp.paiement;
      
              //console.log(paiement)
              //  console.log(paiement)
              if( paiement && elementsData){
                  const _categorie = elementsData?.categories?.find(c => c.categorie_id == paiement?.categorie_id);
                  const _vignette  = elementsData?.typeVignette?.find(c => c.typevg_id == paiement?.typeVignette);
                  const _cartegrise  = elementsData?.typeCarteGrise?.find(c => c.typecg_id == paiement?.typecg_id);
                  const _autorisation = elementsData?.autorisations?.filter(c => c.autorisation_id == paiement?.autorisation_id);
                  let user = '';
                  console.log(_cartegrise);
                  if(paiement?.user_id){
                    api.apiData('get',`/user/${paiement.user_id}`).then((resp) => {
                        setUser(resp.user[0]);
                  });}
            
              // console.log(_categorie[0].nomCategorie)
              let montantplaque = 0;
              if(paiement.type_plaque === "IT")
                montantplaque = 300000.0;
              else if(paiement.type_plaque === "EP" || paiement.type_plaque === "VA")  
                 montantplaque = 350000.0;
          
                let document = paiement?.type_document ? paiement?.type_document:'Non Fournie';
            //     if(paiement[0].type_document === 'tous')
            //       document = 'Tous';
            //     else if(paiement[0].type_document === 'vignette')  
            //       document = 'Vignette';
            //     else if(paiement[0].type_document === 'autorisation')       
            //       document = 'Autorisation de Transport';
            //     else if(paiement[0].type_document === 'mutation')       
            //       document = 'Mutation';    
            //     else if(paiement[0].type_document === 'cartegrise')       
            //       document = 'Carte Grise';     
            //     else if(paiement[0].type_document === 'duplicata')       
            //      document = 'Duplicata';       
            //   else if(paiement[0].type_document === 'changementmodeexp')       
            //      document = 'Changement Mode Exploitation';
            //   else if(paiement[0].type_document === "IT")   
            //      document = "IT";
            //   else if(paiement[0].type_document === "EP")   
            //      document = "EP";   
            //  else if(paiement[0].type_document.toLowerCase() === "ordinaire")   
            //      document = "Ordinaire";    
    
                setPaiementInfo({...paiementInfo,
                  categorie_id:paiement.categorie_id,
                  commission: document !== "Vignette" ? commission(paiement.categorie_id):0,
                  vignette:paiement.typeVignette?paiement.typeVignette:'',
                  cartegrise:paiement?paiement.typecg_id:'',
                  autorisation:paiement.autorisation_id,
                  qrcodepath:paiement.qrcode,
                  reference:paiement.reference,
                  paiement_id:paiement.paiement_id,
                  categorie:_categorie?.nomCategorie,
                  nomCategorie:_categorie?.nomCategorie,
                  vignette:_vignette?_vignette:'',
                  cartegrise:_cartegrise?_cartegrise:'',
                  autorisation:_autorisation?_autorisation[0]:[],
                  expressionCg:_cartegrise ? expression(_cartegrise).expression:'',
                  document:document,
                  quartier_id:paiement.quartier_id,
                  agence_id:paiement.agence_id,
                  created_at:paiement.created_at,
                  user_id:paiement.user_id,
                  username:user.username,
                  status:paiement.status,
                  paiement_id:paiement.paiement_id,
                  type_paiement:paiement.type_paiement,
                  type_document : paiement.type_document,
                  type_plaque:paiement.type_plaque,
                  montantplaque: montantplaque,
                  penalites: paiement.penalite
                });
                setPaiementDetail({...paiementDetail,
                  typeClient:paiement.typeClient,
                  designationOrganisation:paiement?.designationOrganisation,
                  modeExp:paiement.modeExp,
                  fullName:paiement.fullName,
                  tel:paiement.tel,
                  nif:paiement.nif,
                  chassis:paiement.chassis,
                  modeImma:paiement.modeImma,
                  categorieCg:paiement.categorie_id,
                  typeCg:paiement.typecg_id,
                  typeVignette:paiement.typeVignette,
                  pv:paiement.pv,
                  cu:paiement.cu,
                  autorisation_id:paiement.autorisation_id,
                
                });

            }
          }
          setIsLoading(false);  
        });

        setNouveauPrivilege(); setAnnulerPaiement();setValiderPaiement();
        if(privileges){
          privileges.forEach((privilege) => {
            if(privilege.privilege === "Nouveau Paiement"){
              setNouveauPaiement(privilege.privilege);
            }else if(privilege.privilege === "Annuler Paiement"){
              setAnnulerPaiement(privilege.privilege);
            }else if(privilege.privilege === "Valider"){
              setValiderPaiement(privilege.privilege);
            }
          //   else if(privilege.privilege === 'Nouveau Paiement'){
            
          //   }
           })
        }

    }
  }, [elementsData]);
  
  useMemo(() => {
    setElements({...elements,paiementInfo:paiementInfo,paiementDetail:paiementDetail,user:user});
  },[paiementInfo,paiementDetail,user]);

  const handleAnnuler =  () => {
      setErreurs([]);
      setIsRejectionModalOpen(true);
      // setIsLoading(true);
      //   const {status,messages} = await api.apiData('get',`/paiement/status/${paiementInfo.paiement_id}&type=Annuler`);
      // setIsLoading(false);
      // if(status === 200)
      //   navigate('/payment/list');
      // else
      //   setErreurs(messages)  

  }
  const handleValider = async () => {
   setErreurs([]);setIsLoading(true);
    const {status,messages} = await api.apiData('get',`/paiement/status/${paiementInfo.paiement_id}&type=Valider`);
    setIsLoading(false);
    if(status === 200)
      navigate('/payment/list');
    else
      setErreurs(messages)  
  }
  // console.log(validerPaiement)
  return  (
    <div className="payment-invoice page">
       <DocumentTitle title="Details de paiement" />
       <div className="buttons-group space-between">
       <RejectionModal
          isOpen={isRejectionModalOpen}
          setIsOpen={setIsRejectionModalOpen} id={id}
        />
        <div className="left">
          { paiementInfo.status === 1 &&
            <button className="print-btn"  onClick={handlePrint}>
                Imprimer
            </button>
          }
          {/* {(typeof nouveauPrivilege !== 'undefined' && nouveauPrivilege === "Nouveau Paiement") &&
          <button className="primary new-payment-btn" onClick={back} style={{marginRight:'12px'}}>
              Nouveau Paiement
          </button>
          } */}
           {(validerPaiement === "Valider" && paiementInfo.status === 0) &&
             <button className="primary new-payment-btn" onClick={handleValider}>
               Valider
             </button>
           }
       
         
        </div>
        {(typeof annulerPaiement !== 'undefined' && annulerPaiement === "Annuler Paiement" && paiementInfo.status === 0) &&
          <div className="right">
            <button className="delete cancel-btn"  onClick={handleAnnuler}>Annuler paiement</button>
          </div>
         }
          {(typeof nouveauPaiement !== 'undefined' && nouveauPaiement === "Nouveau Paiement") &&
          <div className="right">
            <button className="primary new-payment-btn"  onClick={() => navigate("/payment/new")}>Nouveau</button>
          </div>
         }
       </div>
          {location?.state?.paiementInfo &&(
            <div className="input-group">
                <div>
                  <Erreurs validation={erreurs} />
                </div>
            </div>)}

      {id !== undefined &&(
        <InvoiceDetails ref={componentRef} elements={elements}/>
      )}
    </div>
  );
};

export default PaymentDetails;
